import { render, staticRenderFns } from "./VehicleManagement.vue?vue&type=template&id=60b31d88&scoped=true&"
import script from "./VehicleManagement.vue?vue&type=script&lang=js&"
export * from "./VehicleManagement.vue?vue&type=script&lang=js&"
import style0 from "./VehicleManagement.vue?vue&type=style&index=0&id=60b31d88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b31d88",
  null
  
)

export default component.exports